<template>
  <div class="app-tag-delete-modal t-modal" :class="{ open: isOpen }">
    <div v-down-outside="close" class="content">
      <header>Delete Tag</header>
      <main>
        <div class="message">Are you sure? All items will be deleted.</div>
        <div class="controls">
          <div class="cancel b-btn" @click="close">Cancel</div>
          <div class="confirm b-btn" @click="confirm">Delete</div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { downOutside } from 'app/utils/directives/down-outside';
import { ModalEvents } from 'app/utils/events';

export default {
  name: 'TagDeleteModal',
  components: {},
  directives: {
    downOutside,
  },
  // props: {
  //   tag: {
  //     type: String,
  //     default: null,
  //   },
  // },

  data() {
    return {
      isOpen: false,
      id: '',
    };
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {
    ModalEvents.addListener('deleteTag:open', this.open);
    ModalEvents.addListener('deleteTag:close', this.close);
  },
  destroyed() {
    ModalEvents.removeListener('deleteTag:open', this.open);
    ModalEvents.removeListener('deleteTag:close', this.close);
  },
  methods: {
    open(e) {
      if (e) {
        this.id = e;
      }
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    confirm() {
      this.$store.dispatch('tag/deleteTag', this.id);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.app-tag-delete-modal {

}
</style>
